module.exports = __webpack_public_path__ + "media/images/samples/home/news/n3@2x-e186743fa773b7e4daff43a41f3b70ea.png";